export const ADMIN_ROLES = ['superadmin', 'admin'];

export function hasAllowedRole(profile, allowedRoles = []) {
  return Boolean(
    profile && profile.role && allowedRoles.includes(profile.role.name)
  );
}

export async function canAccessRoleRestrictedRoute(to, store) {
  const allowedRoles = to.meta && to.meta.allowedRoles;
  if (!allowedRoles || allowedRoles.length === 0) return true;

  let profile = store.getters['auth/getProfile'];
  if (!profile || !profile.role) {
    await store.dispatch('auth/loadProfile');
    profile = store.getters['auth/getProfile'];
  }

  return hasAllowedRole(profile, allowedRoles);
}
